import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'container',
  templateUrl: './container.component.html'
})
export class ContainerComponent implements OnInit {

  @Input() table_id: string;
  @Input() data;
  @Input() bulk: number[] = [];
  public test: Array<number> = [];
  @Input() order;
  @Input() orderby;
  @Output() out: EventEmitter<any>;
  @Output() sortby: EventEmitter<any>;
  @Output() change: EventEmitter<any>;

  public identity;
  public apikey;

  constructor() {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.out = new EventEmitter;
    this.sortby = new EventEmitter;
    this.change = new EventEmitter;
    this.apikey = this.identity.apiCompany;
  }

  ngOnInit() {
    // console.log(this.table_id);
   console.log(this.data);
  }

  saveEmit(accion, id, item = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      item: item
    };
    this.out.emit(send);
  }

  sort(by) {
    if (by === this.orderby) {
      if (this.order === 'DESC') {
        this.order = 'ASC';
      } else {
        this.order = 'DESC';
      }
    } else {
      this.orderby = by;
      this.order = 'DESC';
    }

    let order = {
      sort: this.order,
      sortby: this.orderby
    };

    this.sortby.emit(order);
  }

  sorting(by) {
    return this.orderby != by ? 'fa-sort' : (this.order == 'DESC' ? 'fa-sort-desc' : 'fa-sort-asc');
  }

  checkAll() {
    let item;
    for (item of this.data) {
      if (!this.check(item.id)) {
        return false;
      }
    }
    return true;
  }

  check(id) {
    let i;
    for (i of this.bulk) {
      if (i === id) {
        return true;
      }
    }
    return false;
  }

  cleanBulk() {
    this.bulk = [];
    this.change.emit(this.bulk);
  }

  selectAll() {
    let i: number;
    if (this.checkAll()){
      for (i = 0; i < this.data.length; i++) {
        if (this.check(this.data[i].id)) {
          this.selectItem(this.data[i].id);
        }
      }
    } else {
      for (i = 0; i < this.data.length; i++) {
        if (!this.check(this.data[i].id)) {
          this.selectItem(this.data[i].id);
        }
      }
    }
    this.change.emit(this.bulk);
  }

  selectItem(id) {
    // this.bulk = this.test;

    let i, find = false;
    for (i = 0; i < this.bulk.length; i ++) {
      if (this.bulk[i] === id) {
        this.bulk.splice(i , 1);
        find = true;
        break;
      }
    }

    if (!find) {
      this.bulk.push(id);
    }
    // this.test = this.bulk;
    this.change.emit(this.bulk);

  }

  print(id) {
    window.open("https://www.itaderp.com/backend/reports/weight-labels.php?idweight=" + id+"&apikey="+this.apikey);
  }

}
